import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";
import { renderMarkdown } from "@/lib/markdown";

export default function InsightDetail() {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/articles/${slug}`).then(({ data }) => setA(data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="bg-bd-black min-h-screen flex items-center justify-center text-center px-6">
        <div>
          <h1 className="font-serif text-4xl text-bd-ivory mb-4">Article not found</h1>
          <Link to="/insights" className="text-bd-gold hover:text-bd-gold2">← Back to insights</Link>
        </div>
      </div>
    );
  }
  if (!a) return <div className="bg-bd-ivory min-h-screen" />;

  return (
    <div data-testid="page-insight-detail" className="bg-bd-ivory min-h-screen">
      <section className="pt-40 pb-14 bg-bd-black grain relative">
        <div className="relative z-10 max-w-3xl mx-auto px-6 md:px-12">
          <Link to="/insights" className="inline-flex items-center gap-2 text-bd-ivory/50 hover:text-bd-gold transition-colors text-sm mb-8">
            <ArrowLeft size={16} /> Insights
          </Link>
          <p className="overline text-bd-gold mb-5">{a.category}</p>
          <h1 className="font-serif text-3xl md:text-6xl text-bd-ivory leading-[1.08]">{a.title}</h1>
          <p className="mt-6 text-bd-ivory/50 text-sm">
            {a.author ? `By ${a.author}` : "Black Diamond Ventures Group"}
            {a.published_at ? ` · ${new Date(a.published_at).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}` : ""}
          </p>
        </div>
      </section>

      {a.cover_url && (
        <div className="max-w-4xl mx-auto px-6 md:px-12 -mt-8 relative z-10">
          <img src={a.cover_url} alt={a.title} className="w-full aspect-[16/9] object-cover" />
        </div>
      )}

      <article className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          {a.excerpt && <p className="font-serif text-xl md:text-2xl text-black/70 leading-relaxed mb-10 italic">{a.excerpt}</p>}
          <div className="prose-bd" dangerouslySetInnerHTML={{ __html: renderMarkdown(a.body || "") }} />
        </div>
      </article>
    </div>
  );
}
